import Vue from 'vue';
import { mapGetters } from 'vuex';
import AddPage from '../add-page';
import AddTemplate from '../add-template';
import AddDynamic from '../add-dynamic';

export default Vue.component('add-page-tpl', {
  template: require('./template.html'),
  computed: {
    ...mapGetters(['currentSite']),
    showDynamicOption() {
      const { type, addedTypes = [] } = this.currentSite;
      const isGeneral = type === 'general';
      return (!isGeneral || (isGeneral && addedTypes.length > 0));
    },
  },
  data() {
    return {
      modalContent: null,
      unsavedChanges: false,
    };
  },
  props: ['modal'],
  components: {
    AddPage,
    AddTemplate,
    AddDynamic,
  },
  watch: {
    modal(o) {
      if (o) {
        this.unsavedChanges = false;
        this.setModalContent(null);
      }
      this.$store.dispatch('setGlobalOpenModal', o);
    },
  },
  methods: {
    changeUnsaved(v) {
      this.unsavedChanges = v;
    },
    toggleModal() {
      this.$emit('toggle-modal');
    },
    setModalContent(type) {
      this.modalContent = type;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/add-new/index.js